import Vue from 'vue';
import Router from 'vue-router';
import HomePage from './views/HomePage.vue';
import DealsPage from './views/DealsPage.vue';
import ErrorMessage from './components/ErrorMessage.vue';

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage,
    },
    {
      path: '/deals',
      name: 'deals',
      component: DealsPage,
    },
    {
      path: '/suppliers',
      name: 'suppliers',
      component: () => import('./views/SuppliersPage.vue'),
    },
    {
      path: '/distributors',
      name: 'distributors',
      component: () => import('./views/DistributorsPage.vue'),
    },
    {
      path: '/topic/:id',
      name: 'topic',
      component: () => import('./views/TopicStaticPage.vue'),
    },
    {
      path: '/*',
      component: ErrorMessage,
      props: { errorType: '404' },
    },
  ],
});
